import { environment } from './../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AdsService } from 'src/app/private/admin/services/ads.service';
import { EventsService } from 'src/app/private/services/events.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-event-page',
  templateUrl: './event-page.component.html',
  styleUrls: ['./event-page.component.scss']
})
export class EventPageComponent implements OnInit {

  eventDetails: any = [];
  bookedEvents: any[] = [];
  show = false;
  rateEvent: number = 0;
  eventCategory:number

  EVENT_STATUS_CANCELLED = 'CANCELLED';

  allEvents: any = []

  adsListUser:[] = []
  adsListAdmin: any = []

  shuffledAdmin: any = []
  shuffledUser: any = []

  userAd
  adminAd

  firstDate
  lastDate

  isCollapsed:boolean
  isReadMore:boolean

  passedEvent:boolean = false
  categories:any = []

  categoriesTrue: boolean = false

  website: boolean = false
  //Features Status
  bookingFeature:boolean = environment.bookingFeature
  loggedIn:boolean=false

  constructor(private router: Router,
    private appComponent: AppComponent,
    private eventService: EventsService,
    private route: ActivatedRoute,
    private eventsService: EventsService,
    private adsService: AdsService,
    private spinner: NgxSpinnerService
  ) { }

  id: number;
  private sub: any;
  maxLength = 500

   d = new Date();
   year = this.d.getFullYear();
    month = this.d.getMonth()

  async ngOnInit() {
    this.spinner.show();

    if (this.appComponent.isLoggedIn == true){
      this.loggedIn = true
    }
    window.scroll(0, 0);
    this.sub = await this.route.params.subscribe(async (params) => {
      
      // this.id = +params['id']; // (+) converts string 'id' to a number
      await this.eventService.getEvent(params['eventName'])
        .then(async (res: any) => {
          // console.log(res)
          this.eventDetails = res.event;
          if(this.eventDetails.description.length>this.maxLength){
            this.checkDataLength(this.eventDetails);
            this.isCollapsed = true
          }
          if(this.eventDetails.category_list.length < 1 || this.eventDetails.category_list == undefined){
            this.categoriesTrue = false
          } else {  
            for(let i=0;i<this.eventDetails.category_list.length; i++){
            this.categories.push(this.eventDetails.category_list[i].category.name)
          }
        this.categoriesTrue = true
        }
        
          
          if (this.eventDetails.website === null || this.eventDetails.website === ""){ this.website = false} else{this.website = true}


          let dates: any[] = this.eventDetails.event_dates;
          let validDates: any[] = [];
          dates.forEach((date) => {
            if (new Date(date.date) > new Date() || new Date(date.date).toDateString() === new Date().toDateString()) {
              validDates.push(date)
            }
          });
          this.eventDetails.event_dates = validDates;
          
          if (validDates.length < 1 || validDates == undefined){this.passedEvent = true}
          else if(validDates.length == 1){
            this.firstDate= validDates[0].date
          } 
          else {
          this.passedEvent = false 
          this.firstDate = validDates[0].date
          let indexOfArray = validDates.length -1
          this.lastDate = validDates[indexOfArray].date
          }
          
          this.callEvents()
          if (this.appComponent.isLoggedIn === true) {
          await this.eventService.myPickedEvents().then((res: any) => {
            if (res.error != "Unauthorized") {
              // console.log(res)
              let x: any[] = res.picked_events;
              x.forEach((res) => {
                this.bookedEvents.push(res.event_date_id)
              })
            }
          })
            .catch((error) => {
              console.log(error)
            })}
        })
        
        .catch((error) => {
          console.log(error)
        })
        .finally(() => this.spinner.hide());
    });
    await this.adsService.getAllAdsUser().then((res:any) => {
      this.adsListUser=res.ads.data
      this.shuffledUser= this.shuffle(this.adsListUser)
      this.userAd = this.shuffledUser[0]
    })
    await this.adsService.getAllAds("123").then((res:any) => {
      for(let i=0;i<res.ads.data.length; i++){
        if(res.ads.data[i].status == 1){
          this.adsListAdmin.push(res.ads.data[i])
        }
      }
      this.shuffledAdmin= this.shuffle(this.adsListAdmin)
      this.adminAd = this.shuffledAdmin[0]
    })
    // this.spinner.hide()
  }

  checkDataLength(data) {
      if(this.eventDetails.id == data.id){
        if(data.description.length >= 500){
        this.isReadMore = true
  }
      }
  }

  callEvents(){

    let data = {
      "name": "",
      "location": "",
      "country": 123,
      "category": this.eventCategory,
      "year": this.year,
      "month": this.month,
      "sortBy": "",
      "user_id": "",
      "sort_direction": "",
      "day": "",
      "time": "",
      "timeSearch": ""
      }

      this.eventsService.getAllEvents(data).then((res:any) => {

        let array = this.shuffle(res.events.data)
        let j = 2
        for (let i=0; i<j; i++){
          if(res.events.data[i].id == this.eventDetails.id || res.events.data[i].status == "cancelled"){j++}
          else{
        this.allEvents.push({"events":res.events.data[i]})
          }
      }
    })
  }
  isCheckedAndDisabled(item) {
    if (this.bookedEvents.includes(item.id))
      return true;
    return false;
  }

  book(id) {
    if (this.appComponent.isLoggedIn) {
      let data =
      {
        "event_id": parseInt(this.eventDetails.id),
        "event_date_id": parseInt(id)
      };
      if (this.bookedEvents.includes(id)){
        this.eventService.unPickEvent(data)
        .then((res) => {
          // console.log(res)
        })
        .catch((error) => {
          console.log(error)
        })
      }
      else this.eventService.pickEvent(data)
        .then((res) => {
          // console.log(res)
        })
        .catch((error) => {
          console.log(error)
        })
    }
    else {
      this.appComponent.showLogin();
    }
  }

  bookAllDates() {
    let allDates: any[] = this.eventDetails.event_dates
    allDates.forEach((date) => {
      if (!this.bookedEvents.includes(date.id)) {
        let data =
        {
          "event_id": date.event_id,
          "event_date_id": date.id
        };
        this.eventService.bookEvent(data)
          .then((res) => {
            if (allDates.indexOf(date) == allDates.length - 1)
              this.router.navigate(['mybookings'])
          })
      }
    })
  }

  changeRate(){
    // console.log(this.rateEvent)
    // console.log(this.eventDetails.id)
    this.eventService.rateEvent(this.eventDetails.id,this.rateEvent).then((res) => {
      // console.log(res)
    })
  }
 
  goToEventPage(item) {
    this.allEvents = []
    this.router.navigate(['event', item.link]);
  }
  // ===========================================================================
  // Shufle an array
  // ===========================================================================
  shuffle(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  navigate(url){
    window.open("https://"+url, "_blank")
  }

  showHideMap(){
    var x = document.getElementById("mapcontainer");
    if (x.classList.contains("hide")) {
      document.getElementById("maptoggle").innerHTML = "[Show Map]";
      x.classList.remove("hide")
    } else {
      document.getElementById("maptoggle").innerHTML = "[Hide Map]";
      x.classList.add("hide")
    }
    
  }

  goToCalendar(){
    if(this.appComponent.isLoggedIn){
    this.router.navigate(['mybookings'])
    }
    else{
      this.appComponent.showLogin();
    }
  }

  login(){
    if (!this.appComponent.isLoggedIn){
      this.appComponent.showLogin()
    }
  }
  onCopy(event: ClipboardEvent){
    const pagelink = `\n\nRead more at: ${document.location.href}`;
    event.clipboardData.setData('text', document.getSelection() + pagelink);
    event.preventDefault();
  }
}

